<template>
  <!-- Profile Info Tab -->
  <div id="emp_profile" class="pro-overview tab-pane fade show active">
    <div class="row">
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Personal Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                data-bs-target="#personal_info_modal"
                @click="$emit('set-emp-data')"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <ul class="personal-info">
              <!-- <li>
                <div class="title">Passport No.</div>
                <div class="text"> {{ employeeData?.passport_number }}</div>
              </li>
              <li>
                <div class="title">Passport Exp Date.</div>
                <div class="text">  {{ formatDate(employeeData?.passport_expire_at) || employeeData?.passport_expire_at }}</div>
              </li> -->
              <li>
                <div class="title">Tel</div>
                <div class="text">
                  <a href="javascript:;">{{
                    employeeData?.telephone_number
                  }}</a>
                </div>
              </li>
              <!-- <li>
                <div class="title">Nationality</div>
                <div class="text">{{ employeeData?.nationality }}</div>
              </li>
              <li>
                <div class="title">Religion</div>
                <div class="text">{{ employeeData?.religion }}</div>
              </li> -->
              <li>
                <div class="title">Marital status</div>
                <div class="text">
                  <!-- {{
                    employeeData?.marital_status &&
                    employeeData?.marital_status == 1
                      ? "Married"
                      : employeeData?.marital_status == 0
                      ? "Single"
                      : employeeData?.marital_status == 2
                      ? "Divorced" 
                      :employeeData?.marital_status == 3
                      ? "Widow" 
                      : employeeData?.marital_status == 4
                      ? "Seprated" : "-"
                  }} -->
                  {{
                    {
                      0: "Single",
                      1: "Married",
                      2: "Divorced",
                      3: "Widow",
                      4: "Separated",
                    }[employeeData?.marital_status] || "-"
                  }}
                </div>
              </li>
              <!-- <li>
                <div class="title">Employment of spouse</div>
                <div class="text">{{ employeeData?.employment_of_spouse }}</div>
              </li> -->
              <li v-if="uitablestatus == 1">
                <div
                  class="title"
                  v-if="
                    isVisible('profile', 'Personal Information', 'no_of_child')
                  "
                >
                  No. of children
                </div>
                <div
                  class="text"
                  v-if="
                    isVisible('profile', 'Personal Information', 'no_of_child')
                  "
                >
                  {{ employeeData?.no_of_child }}
                </div>
              </li>
              <li v-else>
                <div class="title">No. of children</div>
                <div class="text">{{ employeeData?.no_of_child }}</div>
              </li>

              <!-- <li>
                <div class="title">SSN No.</div>
                <div class="text">{{ employeeData?.ssn_number }}</div>
              </li> -->

              <li v-for="field in personalInfoFields" :key="field.id">
                <div class="title">{{ field.name }}</div>
                <div class="text">{{ field.value ?? "" }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Emergency Contact
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#emergency_contact_modal"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <h5 class="section-title">Primary</h5>
            <ul class="personal-info">
              <li>
                <div class="title">Name</div>
                <div class="text">
                  {{ getEmployeePrimaryContactDetail?.name }}
                </div>
              </li>
              <li>
                <div class="title">Relationship</div>
                <div class="text">
                  {{ getEmployeePrimaryContactDetail?.relationship }}
                </div>
              </li>
              <li>
                <div class="title">Phone</div>
                <div class="text">
                  {{ getEmployeePrimaryContactDetail?.contact_number_1 }}
                  {{
                    getEmployeePrimaryContactDetail?.contact_number_2 != null
                      ? " , "
                      : ""
                  }}
                  {{ getEmployeePrimaryContactDetail?.contact_number_2 }}
                </div>
              </li>
            </ul>
            <hr />
            <h5 class="section-title">Secondary</h5>
            <ul class="personal-info">
              <li>
                <div class="title">Name</div>
                <div class="text">
                  {{ getEmployeeSecondaryContactDetail?.name }}
                </div>
              </li>
              <li>
                <div class="title">Relationship</div>
                <div class="text">
                  {{ getEmployeeSecondaryContactDetail?.relationship }}
                </div>
              </li>
              <li>
                <div class="title">Phone</div>
                <div class="text">
                  {{ getEmployeeSecondaryContactDetail?.contact_number_1 }}
                  {{
                    getEmployeeSecondaryContactDetail?.contact_number_2 != null
                      ? " , "
                      : ""
                  }}
                  {{ getEmployeeSecondaryContactDetail?.contact_number_2 }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Bank Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#employee_bank_modal"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>

            <ul class="personal-info">
              <li>
                <div class="title">Bank name</div>
                <div class="text">{{ getEmployeeBankDetail?.bank_name }}</div>
              </li>
              <li>
                <div class="title">Bank account No.</div>
                <div class="text">
                  {{ getEmployeeBankDetail?.bank_account_number }}
                </div>
              </li>
              <li>
                <div class="title">Bank account name</div>
                <div class="text">
                  {{ getEmployeeBankDetail?.bank_account_name }}
                </div>
              </li>
              <li v-if="uitablestatus == 1">
                <div
                  class="title"
                  v-if="isVisible('profile', 'Bank Information', 'IFSC_code')"
                >
                  IFSC Code
                </div>
                <div
                  class="text"
                  v-if="isVisible('profile', 'Bank Information', 'IFSC_code')"
                >
                  {{ getEmployeeBankDetail?.IFSC_code }}
                </div>
              </li>
              <li v-else>
                <div class="title">IFSC Code</div>
                <div class="text">{{ getEmployeeBankDetail?.IFSC_code }}</div>
              </li>
              <li v-if="uitablestatus == 1">
                <div
                  class="title"
                  v-if="isVisible('profile', 'Bank Information', 'pan_number')"
                >
                  PAN No
                </div>
                <div
                  class="text"
                  v-if="isVisible('profile', 'Bank Information', 'pan_number')"
                >
                  {{ getEmployeeBankDetail?.pan_number }}
                </div>
              </li>
              <li v-else>
                <div class="title">PAN No</div>
                <div class="text">{{ getEmployeeBankDetail?.pan_number }}</div>
              </li>

              <!-- <li v-for="field in bankInfoFields" :key="field.id">
                <div class="title">{{ field.name }}</div>
                <div class="text">{{ field.value ?? "" }}</div>
              </li> -->
              <li v-for="field in bankInfoFields" :key="field.id">
                <div class="title">{{ field.name }}</div>
                <div class="text">
                  <!-- File display -->
                  <template v-if="isFileField(field)">
                    <div v-if="field.slug">
                      <span class="me-2">
                        {{ getFileName(field.value) }}
                      </span>
                      <a
                        v-if="field.value"
                        :href="getFileURL(field.value)"
                        target="_blank"
                        class="btn btn-sm btn-outline-primary"
                      >
                        View
                      </a>
                    </div>
                    <div v-else>-</div>
                  </template>

                  <!-- Text Display -->
                  <template v-else>
                    {{ field.value || "" }}
                  </template>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6 d-flex flex-column">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Family Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#family_info_modal"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <ul class="personal-info">
              <li v-for="field in familyInfoFields" :key="field.id">
                <div class="title">{{ field.name }}</div>
                <div class="text">{{ field.value ?? "" }}</div>
              </li>
            </ul>
            <div class="table-responsive">
              <table class="table table-nowrap">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Relationship</th>
                    <th>Date of Birth</th>
                    <th>Phone</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(emp_fmy_dtl, index) in getFamilyInformation"
                    :key="emp_fmy_dtl?.id"
                  >
                    <td>{{ emp_fmy_dtl?.name }}</td>
                    <td>{{ emp_fmy_dtl?.relationship }}</td>
                    <td>
                      {{
                        formatDate(emp_fmy_dtl?.birth_date) ||
                        emp_fmy_dtl?.birth_date
                      }}
                    </td>
                    <td>{{ emp_fmy_dtl?.contact_number }}</td>
                    <td class="text-end">
                      <div
                        class="dropdown dropdown-action"
                        v-if="hasEditPermission || hasDeletePermission"
                      >
                        <a
                          aria-expanded="false"
                          data-bs-toggle="dropdown"
                          class="action-icon dropdown-toggle"
                          href="javascript:;"
                          ><i class="material-icons">more_vert</i></a
                        >
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="hasEditPermission"
                            href="javascript:;"
                            class="dropdown-item"
                            data-bs-toggle="modal"
                            @click="$emit('set-emp-data')"
                            data-bs-target="#family_info_modal"
                            ><i class="fa fa-pencil m-r-5"></i> Edit</a
                          >
                          <a
                            v-if="hasDeletePermission"
                            href="javascript:;"
                            class="dropdown-item"
                            @click="
                              confirm_delete_family_data(emp_fmy_dtl?.id, index)
                            "
                            ><i class="fa fa-trash-can m-r-5"></i> Delete</a
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-body" v-if="tablestatus == 1">
            <h3 class="card-title">
              Children Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#children_info_modal"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <div class="table-responsive">
              <table class="table table-nowrap">
                <thead>
                  <tr>
                    <th>Child Name</th>
                    <th>Child Gender</th>
                    <th>Child DOB</th>
                    <th>Solo Parent ID</th>
                    <th>Solo Parent Expiry Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(emp_fmy_dtl, index) in getChildrenInformation"
                    :key="emp_fmy_dtl?.id"
                  >
                    <td>{{ emp_fmy_dtl?.child_name }}</td>
                    <td>{{ emp_fmy_dtl?.child_gender }}</td>
                    <td>
                      {{
                        formatDate(emp_fmy_dtl?.child_dob) ||
                        emp_fmy_dtl?.child_dob
                      }}
                    </td>
                    <td>{{ emp_fmy_dtl?.solo_parent_id }}</td>
                    <td>
                      {{
                        formatDate(emp_fmy_dtl?.solo_parent_expiry_date) ||
                        emp_fmy_dtl?.solo_parent_expiry_date
                      }}
                    </td>
                    <td class="text-end">
                      <div
                        class="dropdown dropdown-action"
                        v-if="hasEditPermission || hasDeletePermission"
                      >
                        <a
                          aria-expanded="false"
                          data-bs-toggle="dropdown"
                          class="action-icon dropdown-toggle"
                          href="javascript:;"
                          ><i class="material-icons">more_vert</i></a
                        >
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="hasEditPermission"
                            href="javascript:;"
                            class="dropdown-item"
                            data-bs-toggle="modal"
                            @click="$emit('set-emp-data')"
                            data-bs-target="#children_info_modal"
                            ><i class="fa fa-pencil m-r-5"></i> Edit</a
                          >
                          <a
                            v-if="hasDeletePermission"
                            href="javascript:;"
                            class="dropdown-item"
                            @click="
                              confirm_delete_children_data(
                                emp_fmy_dtl?.id,
                                index
                              )
                            "
                            ><i class="fa fa-trash-can m-r-5"></i> Delete</a
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Education Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#education_info"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <div class="experience-box">
              <ul class="experience-list">
                <li
                  v-for="emp_edu_dtl in getEmployeeEducation"
                  :key="emp_edu_dtl?.id"
                >
                  <div class="experience-user">
                    <div class="before-circle"></div>
                  </div>
                  <div class="experience-content">
                    <div class="timeline-content">
                      <a href="#/" class="name">{{
                        emp_edu_dtl?.institution
                      }}</a>
                      <div>
                        {{ emp_edu_dtl?.subject }} - {{ emp_edu_dtl?.degree }}
                      </div>
                      <span class="time"
                        >{{
                          formatDate(emp_edu_dtl?.starting_date) ||
                          emp_edu_dtl?.starting_date
                        }}
                        {{ emp_edu_dtl?.starting_date != null ? " - " : "" }}
                        {{
                          formatDate(emp_edu_dtl?.complete_date) ||
                          emp_edu_dtl?.complete_date
                        }}</span
                      >
                      <div v-if="emp_edu_dtl?.documents">
                        <div
                          v-for="(document, index) in emp_edu_dtl.documents"
                          :key="'edu_document_' + index"
                        >
                          <router-link
                            to="#"
                            @click="viewDoc(document?.file_path)"
                          >
                            <span
                              ><i class="fa fa-file" aria-hidden="true"></i>
                              {{ document?.original_file_name }}</span
                            >
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Experience
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                @click="$emit('set-emp-data')"
                data-bs-target="#experience_info"
                ><i class="fas fa-pencil-alt"></i
              ></a>
            </h3>
            <div class="experience-box">
              <ul class="experience-list">
                <li v-for="emp_exp in getEmployeeExperience" :key="emp_exp?.id">
                  <div class="experience-user">
                    <div class="before-circle"></div>
                  </div>
                  <div class="experience-content">
                    <div class="timeline-content">
                      <a href="#/" class="name">{{ emp_exp?.company_name }}</a>
                      <span class="time"
                        >{{ emp_exp?.job_period_from }}
                        {{ emp_exp?.job_period_from != null ? " - " : "" }}
                        {{ emp_exp?.job_period_to }}</span
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Other Document Information
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                data-bs-target="#upload_documents"
                @click="clearData"
                ><i class="fas fa-plus"></i
              ></a>
            </h3>
            <div class="raw">
              <div class="col-md-12">
                <div class="showentries mb-3">
                  <label
                    >Show
                    <select
                      v-model="pagination.pageSize"
                      @change="updatePagination"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    entries
                  </label>
                </div>
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :data-source="documentData"
                    :pagination="pagination"
                    @change="handleTableChange"
                  >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'original_file_name'">
                        <a
                          href="javascript:;"
                          @click="viewDoc(record?.file_path)"
                        >
                          <i class="fa fa-file" aria-hidden="true"></i>
                          {{ record.original_file_name }}
                        </a>
                      </template>

                      <template v-if="column.key === 'action'">
                        <div class="text-end">
                          <div class="dropdown dropdown-action">
                            <a
                              href="javascript:;"
                              class="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              ><i class="material-icons">more_vert</i></a
                            >
                            <div class="dropdown-menu dropdown-menu-right">
                              <a
                                href="javascript:;"
                                class="dropdown-item"
                                @click="viewDoc(record?.file_path)"
                              >
                                <i class="fa fa-eye m-r-5"></i> View
                              </a>

                              <a
                                v-if="hasEditPermission"
                                class="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_upload_documents"
                                @click="editDocModal(record)"
                                ><i class="fa-regular fa-edit m-r-5"></i>
                                Edit</a
                              >
                              <a
                                v-if="hasDeletePermission"
                                class="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_document"
                                @click="setDeleteID(record?.user_documents_id)"
                                ><i class="fa-regular fa-trash-can m-r-5"></i>
                                Delete</a
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 d-flex">
        <div class="card profile-box flex-fill">
          <div class="card-body">
            <h3 class="card-title">
              Certificates
              <a
                v-if="hasEditPermission"
                href="javascript:;"
                class="edit-icon"
                data-bs-toggle="modal"
                data-bs-target="#manage_certificates"
                @click="clearCertiData"
                ><i class="fas fa-plus"></i
              ></a>
            </h3>
            <div class="raw">
              <div class="col-md-12">
                <div class="showentries mb-3">
                  <label
                    >Show
                    <select
                      v-model="certi_pagination.pageSize"
                      @change="updateCertiPagination"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    entries
                  </label>
                </div>
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="certiColumns"
                    :data-source="CertiData"
                    :pagination="certi_pagination"
                    @change="handleCertiTableChange"
                  >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'course_name'">
                        {{ record?.course_name }} - {{ record?.company_name }}
                      </template>

                      <template v-if="column.key === 'file_original_name'">
                        <a
                          href="javascript:;"
                          @click="viewDoc(record?.file_path)"
                        >
                          <i class="fa fa-file" aria-hidden="true"></i>
                          {{ record.file_original_name }}
                        </a>
                      </template>

                      <template v-if="column.key === 'action'">
                        <div class="text-end">
                          <div class="dropdown dropdown-action">
                            <a
                              href="javascript:;"
                              class="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              ><i class="material-icons">more_vert</i></a
                            >
                            <div class="dropdown-menu dropdown-menu-right">
                              <a
                                href="javascript:;"
                                class="dropdown-item"
                                @click="viewDoc(record?.file_path)"
                              >
                                <i class="fa fa-eye m-r-5"></i> View
                              </a>
                              <a
                                v-if="hasEditPermission"
                                class="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                                data-bs-target="#manage_certificates"
                                @click="editCertificateModal(record)"
                                ><i class="fa-regular fa-edit m-r-5"></i>
                                Edit</a
                              >
                              <a
                                v-if="hasDeletePermission"
                                class="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                                data-bs-target="#delete_certi"
                                @click="
                                  deleteCertiID(record?.user_certificate_id)
                                "
                                ><i class="fa-regular fa-trash-can m-r-5"></i>
                                Delete</a
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Documents -->
    <div id="upload_documents" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Upload Documents</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearData"
              ref="upload_documents_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <Form @submit="addNewDoc">
              <div class="row">
                <div class="col-md-12">
                  <!-- <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Document Name <span class="text-danger">*</span></label
                    >
                    <Field
                      type="text"
                      name="document_title"
                      class="form-control"
                      v-model="document.document_title"
                      :class="{ 'is-invalid': errors.document_title }"
                    />
                    <div class="invalid-feedback">
                      {{ errors.document_title }}
                    </div>
                    <div
                      class="document_titlesshow text-danger"
                      id="document_title"
                    ></div>
                  </div> -->
                  <!-- <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Select Document <span class="text-danger">*</span></label
                    >
                    <div
                      v-for="(fileInput, index) in fileInputs"
                      :key="fileInput.id"
                      class="d-flex mb-2"
                    >
                      <Field
                        type="file"
                        class="form-control me-2"
                        data-buttontext="Choose File"
                        data-icon="false"
                        data-classbutton="btn btn-default"
                        data-classinput="form-control inline input-s"
                        name="document"
                        accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .xlsx, .xls"
                        :ref="'fileInput' + index"
                        @change="handleImageChange($event, index)"
                      />
                      <button
                        v-if="fileInputs.length > 1"
                        type="button"
                        class="btn btn-danger"
                        @click="removeFileInput(index)"
                      >
                        Remove
                      </button>
                    </div>

                    <button
                      type="button"
                      class="btn btn-success mt-2"
                      @click="addFileInput"
                    >
                      + Add File
                    </button>
                  </div> -->

                  <div class="input-block mb-3">
                    <label class="col-form-label"
                      >Select Document <span class="text-danger">*</span></label
                    >
                    <input
                      type="file"
                      class="form-control"
                      :ref="'fileInputMultiple'"
                      multiple
                      @change="handleImageChange"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.rtf,.odt,.ods,.jpg,.jpeg,.png,.gif,.bmp,.tiff,.csv,.zip,.html,.htm,.ppt,.pptx"
                    />

                    <ul v-if="documents.length" class="mt-2">
                      <li
                        v-for="(file, index) in documents"
                        :key="index"
                        class="mb-2"
                      >
                        {{ file.name }}
                        <button
                          type="button"
                          class="btn btn-sm btn-danger ms-2"
                          @click="removeFileInput(index)"
                        >
                          Remove
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- NOTE -->
              <small class="form-text text-muted mt-2">
                <i class="fas fa-info-circle"></i>
                Note: The uploaded file’s name will automatically be used as the
                document name (without extension).
              </small>
              <div class="submit-section">
                <button
                  class="btn btn-primary submit-btn"
                  :disabled="disableButton"
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Documents -->

    <!-- Edit Documents -->
    <div
      id="edit_upload_documents"
      class="modal custom-modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Documents</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearEditData"
              ref="edit_documents_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <Form @submit="editDoc">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-block mb-3">
                    <label class="col-form-label">Document Name</label>
                    <input
                      type="text"
                      name="document_title"
                      class="form-control"
                      v-model="docData.document_title"
                    />
                    <span
                      class="text-danger"
                      v-if="
                        errors &&
                        errors?.document_title &&
                        errors?.document_title != null
                      "
                    >
                      {{ errors?.document_title[0] }}
                    </span>
                  </div>
                  <div class="input-block mb-3">
                    <label class="col-form-label">Select Document</label>
                    <Field
                      type="file"
                      class="form-control me-2"
                      data-buttontext="Choose File"
                      data-icon="false"
                      data-classbutton="btn btn-default"
                      data-classinput="form-control inline input-s"
                      name="document"
                      accept=".jpg, .jpeg, .png, .doc, .docx, .pdf, .xlsx, .xls"
                      ref="docInput"
                      @change="handleFileChange($event)"
                    />
                  </div>
                </div>
              </div>
              <small v-if="docData?.user_documents_id"
                >Provide the document only if you wish to replace the existing
                one</small
              >

              <div class="submit-section">
                <button
                  class="btn btn-primary submit-btn"
                  :disabled="disableButton"
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Documents -->

    <!-- Delete Asset Modal -->
    <div class="modal custom-modal fade" id="delete_document" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Delete Document</h3>
              <p>Are you sure want to delete?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary continue-btn"
                    @click="deleteDocument"
                    :disabled="disableButton"
                    >Delete</a
                  >
                </div>
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    data-bs-dismiss="modal"
                    ref="close_document_delete_modal"
                    class="btn btn-primary cancel-btn"
                    >Cancel</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Delete Asset Modal -->

    <!-- Delete Certi Modal -->
    <div class="modal custom-modal fade" id="delete_certi" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            <div class="form-header">
              <h3>Delete Certificate</h3>
              <p>Are you sure want to delete?</p>
            </div>
            <div class="modal-btn delete-action">
              <div class="row">
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    class="btn btn-primary continue-btn"
                    @click="deleteCertificate"
                    :disabled="disableButton"
                    >Delete</a
                  >
                </div>
                <div class="col-6">
                  <a
                    href="javascript:void(0);"
                    data-bs-dismiss="modal"
                    ref="close_certi_delete_modal"
                    class="btn btn-primary cancel-btn"
                    >Cancel</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Delete Certi Modal -->

    <!-- Add Certificate -->
    <div id="manage_certificates" class="modal custom-modal fade" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ certificateData[0]?.user_certificate_id ? "Edit " : "Add " }}
              Certificate
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="clearCertiData"
              ref="upload_certi_close"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-scroll">
              <div
                class="card"
                v-for="(certi, index) in certificateData"
                :key="'certificate_' + certi.key"
              >
                <div class="card-body">
                  <h3 class="card-title">
                    Certificate Information
                    <a
                      @click="confirm_delete_certificate_data(certi?.id, index)"
                      href="javascript:void(0);"
                      class="delete-icon"
                      ><i class="far fa-trash-alt"></i
                    ></a>
                  </h3>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >Company Name
                          <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          name="company_name"
                          class="form-control"
                          v-model="certi.company_name"
                        />
                        <span
                          class="text-danger"
                          v-if="
                            errors &&
                            errors['certificates.' + index + '.company_name'] &&
                            errors['certificates.' + index + '.company_name'] !=
                              null
                          "
                          >{{
                            errors["certificates." + index + ".company_name"][0]
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >Course Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          name="course_name"
                          class="form-control"
                          v-model="certi.course_name"
                        />
                        <span
                          class="text-danger"
                          v-if="
                            errors &&
                            errors['certificates.' + index + '.course_name'] &&
                            errors['certificates.' + index + '.course_name'] !=
                              null
                          "
                          >{{
                            errors["certificates." + index + ".course_name"][0]
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >From : <span class="text-danger">*</span></label
                        >
                        <datepicker
                          v-model="certi.from"
                          placeholder="Choose Date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                        <span
                          class="text-danger"
                          v-if="
                            errors &&
                            errors['certificates.' + index + '.from_date'] &&
                            errors['certificates.' + index + '.from_date'] !=
                              null
                          "
                          >{{
                            errors["certificates." + index + ".from_date"][0]
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >To : <span class="text-danger">*</span></label
                        >
                        <datepicker
                          v-model="certi.to"
                          placeholder="Choose Date"
                          class="form-control datetimepicker"
                          :editable="true"
                          :clearable="false"
                          :input-format="dateFormat"
                        />
                        <span
                          class="text-danger"
                          v-if="
                            errors &&
                            errors['certificates.' + index + '.to_date'] &&
                            errors['certificates.' + index + '.to_date'] != null
                          "
                          >{{
                            errors["certificates." + index + ".to_date"][0]
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-block mb-3">
                        <label class="col-form-label"
                          >Upload Certificate
                          <span class="text-danger">*</span></label
                        >
                        <Field
                          type="file"
                          class="form-control"
                          data-buttontext="Choose File"
                          data-icon="false"
                          data-classbutton="btn btn-default"
                          data-classinput="form-control inline input-s"
                          name="certificate"
                          multiple
                          accept=".jpg, .jpeg, .png, .doc, .docx, .pdf"
                          ref="certi_attachments"
                          @change="handleCertiImageChange($event, index)"
                        />
                        <small v-if="certi?.user_certificate_id"
                          >Provide the document only if you wish to replace the
                          existing one</small
                        >
                        <span
                          class="text-danger"
                          v-if="
                            errors &&
                            errors['certificates.' + index + '.certificate'] &&
                            errors['certificates.' + index + '.certificate'] !=
                              null
                          "
                          >{{
                            errors["certificates." + index + ".certificate"][0]
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="add-more"
                v-if="!certificateData[0].user_certificate_id"
              >
                <a href="javascript:void(0);" @click="addMoreCertificate()"
                  ><i class="fa fa-plus-circle"></i> Add More</a
                >
              </div>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn" @click="addNewCerti">
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add Certificate -->
  </div>
  <!-- /Profile Info Tab -->
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { notification } from "ant-design-vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import { ref } from "vue";
import moment from "moment";
const fromCurrentDate = ref(new Date());
const toCurrentDate = ref(new Date());
var pagination = { total: 0, current: 1, pageSize: 10 };

const columns = [
  {
    title: "Document Title",
    dataIndex: "document_title",
    key: "asset_user_name",
    sorter: {
      compare: (a, b) => {
        a = a.document_title.toLowerCase();
        b = b.document_title.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Original File Name",
    dataIndex: "original_file_name",
    key: "original_file_name",
    sorter: {
      compare: (a, b) => {
        a = a.original_file_name.toLowerCase();
        b = b.original_file_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  // {
  //   title: "File Extension",
  //   dataIndex: "document_type",
  //   key:"document_type",
  //   sorter: {
  //     compare: (a, b) => {
  //       a = a.document_type.toLowerCase();
  //       b = b.document_type.toLowerCase();
  //       return a > b ? -1 : b > a ? 1 : 0;
  //     },
  //   },
  // },

  {
    title: "Action",
    key: "action",
    sorter: true,
    class: "text-end",
  },
];

const certiColumns = [
  // {
  //   title: "Company Name",
  //   dataIndex: "company_name",
  //   key:"company_name",
  //   sorter: {
  //     compare: (a, b) => {
  //       a = a.company_name.toLowerCase();
  //       b = b.company_name.toLowerCase();
  //       return a > b ? -1 : b > a ? 1 : 0;
  //     },
  //   },
  // },
  {
    title: "Course Name",
    dataIndex: "course_name",
    key: "course_name",
    sorter: {
      compare: (a, b) => {
        a = a.course_name.toLowerCase();
        b = b.course_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Certificate",
    dataIndex: "file_original_name",
    key: "file_original_name",
    sorter: {
      compare: (a, b) => {
        a = a.file_original_name.toLowerCase();
        b = b.file_original_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
    class: "text-end",
  },
];

export default {
  emits: ["reload-data", "set-emp-data"],
  props: {
    fields: { type: Object, required: true },
    uifields: { type: Object, required: true },
    employeeData: {
      type: Object,
      default: null,
    },
    hasEditPermission: {
      type: Boolean,
      default: true,
    },
    hasDeletePermission: {
      type: Boolean,
      default: true,
    },
    tablestatus: {
      type: Boolean,
      default: 0,
    },
    uitablestatus: {
      type: Boolean,
      default: 0,
    },
  },
  watch: {
    employeeData(newVal) {
      this.documentData = newVal?.user_documents || [];
      this.CertiData = newVal?.user_certificate || [];
    },
  },
  data() {
    return {
      dateFormat: "dd-MM-yyyy",
      fileInputs: [{ id: Date.now(), file: null }],
      documents: [],
      certificateData: [
        {
          id: null,
          key: Date.now() + Math.random(),
          company_name: "",
          course_name: null,
          from: fromCurrentDate,
          to: toCurrentDate,
          certificate: null,
        },
      ],
      docData: {
        id: null,
        document_title: "",
        document: null,
      },
      errors: null,
      disableButton: false,
      perpage: 10,
      pagination: pagination,
      certi_pagination: Object.assign({}, pagination),
      documentData: [],
      columns,
      deleteID: null,
      certiColumns,
      CertiData: [],
      deleteCerti_ID: null,
    };
  },
  components: {
    Form,
    Field,
  },
  computed: {
    bankInfoFields() {
      // only "emp_profile" → "Personal Information"
      return this.fields?.emp_profile?.["Bank Information"] || [];
    },
    personalInfoFields() {
      // only "emp_profile" → "Personal Information"
      return this.fields?.emp_profile?.["Personal Information"] || [];
    },
    familyInfoFields() {
      return this.fields?.emp_profile?.["Family Information"] || [];
    },
    getEmployeePrimaryContactDetail() {
      if (
        this?.employeeData?.employee_contact &&
        this.employeeData.employee_contact != null
      ) {
        return (
          this.employeeData.employee_contact.find(
            (contact) => contact.contact_type === "p"
          ) || null
        );
      }
    },
    getEmployeeSecondaryContactDetail() {
      if (
        this?.employeeData?.employee_contact &&
        this.employeeData.employee_contact != null
      ) {
        return (
          this.employeeData.employee_contact.find(
            (contact) => contact.contact_type === "s"
          ) || null
        );
      }
    },
    getEmployeeBankDetail() {
      if (
        this?.employeeData?.employee_bank_detail &&
        this.employeeData.employee_bank_detail != null
      ) {
        return this.employeeData.employee_bank_detail[0];
      }
    },
    getFamilyInformation() {
      if (
        this?.employeeData?.employee_family_detail &&
        this?.employeeData?.employee_family_detail != null
      ) {
        return this.employeeData.employee_family_detail;
      }
    },
    getChildrenInformation() {
      if (
        this?.employeeData?.employee_children_detail &&
        this?.employeeData?.employee_children_detail != null
      ) {
        return this.employeeData.employee_children_detail;
      }
    },
    getEmployeeEducation() {
      if (
        this?.employeeData?.education_information &&
        this?.employeeData?.education_information != null
      ) {
        return this.employeeData.education_information;
      }
    },
    getEmployeeExperience() {
      if (
        this?.employeeData?.employee_experience &&
        this?.employeeData?.employee_experience != null
      ) {
        return this.employeeData.employee_experience;
      }
    },
  },
  methods: {
    ...mapActions([
      "deleteFamilyDetails",
      "deleteChildDetails",
      "fetchEmployeeProfileData",
      "getDateFormate",
    ]),
    isFileField(field) {
      return field.field_type === "file";
    },
    getFileName(fileValue) {
      if (typeof fileValue === "string") {
        return fileValue.split("/").pop();
      }
      return fileValue || "";
    },
    getFileURL(fileValue) {
      if (typeof fileValue === "string") {
        return process.env.VUE_APP_IMAGE_BASE_URL + fileValue;
      } else if (fileValue instanceof File) {
        return URL.createObjectURL(fileValue);
      }
      return "#";
    },
    isVisible(tab, section, column) {
      return (
        this.uifields?.[tab]?.[section]?.some(
          (f) => f.column === column && f.is_visible
        ) ?? false
      );
    },
    editCertificateModal(record) {
      this.certificateData = [
        {
          id: record?.id || null,
          company_name: record?.company_name || "",
          course_name: record?.course_name || "",
          from: new Date(record?.from_date),
          to: new Date(record?.to_date),
          certificate: null,
          user_certificate_id: record?.user_certificate_id || null,
        },
      ];
    },
    editDocModal(record) {
      console.log(record);

      this.docData = {
        id: record?.id || null,
        document_title: record?.document_title || "",
        document: null,
        user_documents_id: record?.user_documents_id || null,
      };
    },
    deleteCertiID(id) {
      this.deleteCerti_ID = id;
    },
    addMoreCertificate() {
      if (this.certificateData.length < 5) {
        this.certificateData.push({
          id: null,
          key: Date.now() + Math.random(),
          company_name: "",
          course_name: null,
          from: fromCurrentDate,
          to: toCurrentDate,
          certificate: null,
        });
      } else {
        notification.open({
          message: "Max 5 Eductaion details you can add!",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
      }
    },
    addNewCerti() {
      this.errors = [];
      this.disableButton = true;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      this.certificateData.forEach((c) => {
        c.from_date = moment(c.from).format("YYYY-MM-DD");
        c.to_date = moment(c.to).format("YYYY-MM-DD");
      });

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      if (
        this.certificateData.length === 1 &&
        this.certificateData[0].user_certificate_id
      ) {
        axios
          .post(
            "employee/profile/edit-certificate/" +
              this.certificateData[0]?.user_certificate_id,
            this.certificateData[0],
            config
          )
          .then((response) => {
            loader.hide();
            this.disableButton = false;
            this.$emit("reload-data");
            notification.open({
              message: response?.data?.message || "Successfully Added",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });

            this.$refs.upload_certi_close.click();
          })
          .catch((error) => {
            this.disableButton = false;
            loader.hide();
            if (error.response) {
              var response = error.response;

              this.errors = response?.data?.errors || [];

              notification.open({
                message: response?.data?.message || "Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            } else {
              notification.open({
                message: "Server Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          });
      } else {
        axios
          .post(
            "employee/profile/add-certificate/" + this?.$route?.params?.user_id,
            this.certificateData,
            config
          )
          .then((response) => {
            loader.hide();
            this.disableButton = false;
            this.$emit("reload-data");
            notification.open({
              message: response?.data?.message || "Successfully Added",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });

            this.$refs.upload_certi_close.click();
          })
          .catch((error) => {
            this.disableButton = false;
            loader.hide();
            if (error.response) {
              var response = error.response;

              this.errors = response?.data?.errors || [];

              notification.open({
                message: response?.data?.message || "Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            } else {
              notification.open({
                message: "Server Error",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          });
      }
    },
    async confirm_delete_certificate_data(emp_edu_id, index) {
      console.log("delete certi", emp_edu_id, index);

      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      }).then(async (t) => {
        if (t.value) {
          if (emp_edu_id && emp_edu_id != null) {
            const response = await this.deleteCertificate(emp_edu_id);
            if (response.status == 200) {
              this.$emit("reload-data");
              notification.open({
                message: "Successfully Data deleted.",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_SUCCESS_COLOR,
                },
              });
            } else {
              // this.selectedImage = null;
              notification.open({
                message: response?.message
                  ? response?.message
                  : "Something went wrong, Please try again later",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          } else if (index != null) {
            this.certificateData.splice(index, 1);
            notification.open({
              message: "Successfully Data deleted.",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_SUCCESS_COLOR,
              },
            });
          }

          if (this.certificateData.length == 0) {
            this.certificateData.push({
              id: null,
              key: Date.now() + Math.random(),
              company_name: "",
              course_name: null,
              from: fromCurrentDate,
              to: toCurrentDate,
              certificate: null,
            });
          }
        }
      });
    },
    clearCertiData() {
      this.certificateData = [
        {
          id: null,
          key: Date.now() + Math.random(),
          company_name: "",
          course_name: null,
          from: fromCurrentDate,
          to: toCurrentDate,
          certificate: null,
        },
      ];

      this.errors = null;

      if (this.$refs.certi_attachments && this.$refs.certi_attachments.$el) {
        this.$refs.certi_attachments.$el.value = "";
        this.$refs.certi_attachments.value = "";
      }
    },
    setDeleteID(deleteId) {
      this.deleteID = deleteId;
    },
    handleTableChange(pagesize) {
      var params = {
        params: { per_page: pagesize?.pageSize, page: pagesize?.current },
      };
      this.fetchData(params);
    },
    handleCertiTableChange(pagesize) {
      var params = {
        params: { per_page: pagesize?.pageSize, page: pagesize?.current },
      };
      this.fetchCertiData(params);
    },
    updatePagination() {
      this.fetchData(null);
    },

    updateCertiPagination() {
      this.fetchCertiData(null);
    },

    handleCertiImageChange(event, index) {
      const file = event.target.files[0] || null;
      this.certificateData[index].certificate = file;
    },

    // handleImageChange(event, index) {
    //   const file = event.target.files[0] ?? null;
    //   if (!file) {
    //     if (index < this.documents.length)
    //       this.documents.splice(index, 1, null);
    //     return;
    //   }

    //   if (index >= this.documents.length) {
    //     for (let i = this.documents.length; i <= index; i++) {
    //       this.documents[i] = null;
    //     }
    //   }

    //   this.documents[index] = file;
    // },
    handleImageChange(e) {
      const selectedFiles = Array.from(e.target.files);
      this.documents.push(...selectedFiles);
    },
    async fetchData(params = null) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var param = null;

      if (params != null) {
        param = params;
      } else {
        param = {
          params: { per_page: this.pagination.pageSize },
        };
      }

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      await axios
        .get(
          "/employee/profile/user-documents/" + this.$route.params.user_id,
          param
        )
        .then((response) => {
          loader.hide();

          this.documentData = response?.data?.data?.data || [];

          this.pagination.total = response?.data?.data?.total;
          this.pagination.current = response?.data?.data?.current_page;
          this.pagination.pageSize = response?.data?.data?.per_page;
        })
        .catch((error) => {
          loader.hide();
          if (
            error?.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          }

          if (error?.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error During Fetching Overtime Records",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    async fetchCertiData(params = null) {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var param = null;

      if (params != null) {
        param = params;
      } else {
        param = {
          params: { per_page: this.certi_pagination.pageSize },
        };
      }

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      await axios
        .get(
          "/employee/profile/user-certificate/" + this.$route.params.user_id,
          param
        )
        .then((response) => {
          loader.hide();

          this.CertiData = response?.data?.data?.data || [];

          this.certi_pagination.total = response?.data?.data?.total;
          this.certi_pagination.current = response?.data?.data?.current_page;
          this.certi_pagination.pageSize = response?.data?.data?.per_page;
        })
        .catch((error) => {
          loader.hide();
          if (
            error?.response?.status == 401 &&
            response?.data?.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          }

          if (error?.response) {
            var response = error.response;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error During Fetching Overtime Records",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    clearData() {
      this.documents = [];
      this.fileInputs = [{ id: Date.now(), file: null }];
      this.errors = [];
      // if (this.$refs.attachments && this.$refs.attachments.$el) {
      //   this.$refs.attachments.$el.value = "";
      //   this.$refs.attachments.value = "";
      // }
    },
    clearEditData() {
      this.docData = {
        id: null,
        document_title: "",
        document: null,
      };
      this.errors = [];
    },
    addFileInput() {
      this.fileInputs.push({ id: Date.now() + Math.random(), file: null });
    },
    removeFileInput(index) {
      this.fileInputs.splice(index, 1);
      this.documents.splice(index, 1);
      this.$refs.fileInputMultiple.value = null;
    },
    addNewDoc() {
      this.errors = [];
      this.disableButton = true;
      if (!this.documents.length) {
        this.disableButton = false;
        notification.open({
          message: "Please select at least one file",
          placement: "topRight",
          duration: process.env.VUE_APP_NOTIFICATION_DURATION,
          style: {
            background: process.env.VUE_APP_WARNING_COLOR,
          },
        });
        return;
      }
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const formData = new FormData();
      this.documents.forEach((file, index) => {
        if (file) {
          formData.append("documents[]", file);
        }
      });

      axios
        .post(
          "employee/profile/upload-document/" + this?.$route?.params?.user_id,
          formData,
          config
        )
        .then((response) => {
          loader.hide();
          this.disableButton = false;
          this.$emit("reload-data");
          notification.open({
            message: response?.data?.message || "Successfully uploaded",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.upload_documents_close.click();
        })
        .catch((error) => {
          this.disableButton = false;
          loader.hide();
          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || [];

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    handleFileChange(event) {
      const file = event.target.files[0] ?? null;
      this.docData.document = file;
    },
    editDoc() {
      this.errors = [];
      this.disableButton = true;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      const token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      const formData = new FormData();
      formData.append("document_title", this.docData.document_title || "");

      if (this.docData.document) {
        formData.append("document", this.docData.document);
      }
      console.log(this.docData);
      console.log(this.docData.user_documents_id);

      axios
        .post(
          `employee/profile/update-document/${this.docData.user_documents_id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          loader.hide();
          this.disableButton = false;

          this.$emit("reload-data");
          notification.open({
            message: response?.data?.message || "Successfully updated",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.edit_documents_close.click();
        })
        .catch((error) => {
          loader.hide();
          this.disableButton = false;
          this.errors = error.response?.data?.error || [];

          if (error.response) {
            notification.open({
              message: error.response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },

    viewDoc(file) {
      window.open(`${process.env.VUE_APP_IMAGE_BASE_URL}${file}`, "_blank");
    },

    deleteDocument() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .delete("employee/profile/user-documents/" + this?.deleteID)
        .then((response) => {
          this.deleteID = null;

          loader.hide();
          this.disableButton = false;
          this.$emit("reload-data");
          notification.open({
            message: response?.data?.message || "Successfully Deleted",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.close_document_delete_modal.click();
        })
        .catch((error) => {
          this.disableButton = false;
          loader.hide();
          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || [];

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },

    deleteCertificate() {
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .delete("employee/profile/user-certificate/" + this?.deleteCerti_ID)
        .then((response) => {
          this.deleteCerti_ID = null;

          loader.hide();
          this.disableButton = false;
          this.$emit("reload-data");
          notification.open({
            message: response?.data?.message || "Successfully Deleted",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.close_certi_delete_modal.click();
        })
        .catch((error) => {
          this.disableButton = false;
          loader.hide();
          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || [];

            notification.open({
              message: response?.data?.message || "Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    async confirm_delete_family_data(emp_family_id, index) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      }).then(async (t) => {
        if (t.value) {
          if (emp_family_id && emp_family_id != null) {
            const response = await this.deleteFamilyDetails(emp_family_id);
            if (response.status == 200) {
              await this.fetchEmployeeProfileData(this?.employeeData?.id);
              notification.open({
                message: "Successfully Data deleted.",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_SUCCESS_COLOR,
                },
              });
            } else {
              this.selectedImage = null;
              notification.open({
                message: response?.message
                  ? response?.message
                  : "Something went wrong, Please try again later",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          }
        }
      });
    },
    async confirm_delete_children_data(emp_family_id, index) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      }).then(async (t) => {
        if (t.value) {
          if (emp_family_id && emp_family_id != null) {
            const response = await this.deleteChildDetails(emp_family_id);
            if (response.status == 200) {
              this.$emit("reload-data");
              //await this.fetchEmployeeProfileData(this?.employeeData?.id);
              notification.open({
                message: "Successfully Data deleted.",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_SUCCESS_COLOR,
                },
              });
            } else {
              this.selectedImage = null;
              notification.open({
                message: response?.message
                  ? response?.message
                  : "Something went wrong, Please try again later",
                placement: "topRight",
                duration: process.env.VUE_APP_NOTIFICATION_DURATION,
                style: {
                  background: process.env.VUE_APP_WARNING_COLOR,
                },
              });
            }
          }
        }
      });
    },
  },
  setup() {
    // const schema = Yup.object().shape({
    //   document_title: Yup.string().required("Title is required"),
    //   document: Yup.mixed().required("File is required"),
    // });
    const schema = Yup.object().shape({
      document: Yup.mixed().required("At least one file is required"),
    });

    const Certischema = Yup.object().shape({
      company_name: Yup.string().required("Company Name is required"),
      course_name: Yup.string().required("Course Name is required"),
      certificate: Yup.mixed().required("Certificate File is required"),
    });

    const EditCertischema = Yup.object().shape({
      company_name: Yup.string().required("Company Name is required"),
      course_name: Yup.string().required("Course Name is required"),
    });
    return {
      schema,
      Certischema,
      EditCertischema,
    };
  },
};
</script>
